import { render } from "./Highlighter.vue?vue&type=template&id=ccac7132"
import script from "./Highlighter.vue?vue&type=script&lang=js"
export * from "./Highlighter.vue?vue&type=script&lang=js"

import exportComponent from "/Users/johan/dev/litteraturkartan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__